/**
 * Custom Swiper Slideshow
 * Rebuild for performance and stability
 */

(function () {
  const initCustomSlideshow = () => {
    const slideshows = document.querySelectorAll('[data-slideshow-id]');

    if (slideshows.length === 0) return;

    slideshows.forEach(el => {
      if (el.dataset.initialized === 'true') return;

      const slides = el.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      // Check if Swiper is loaded
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded yet');
        return;
      }

      el.dataset.initialized = 'true';

      const autoplay = el.dataset.autoplay === 'true';
      const speed = parseInt(el.dataset.speed) || 5000;
      const transition = el.dataset.transition || 'slide';

      const paginationEl = el.querySelector('.swiper-pagination');
      const nextEl = el.querySelector('.swiper-button-next');
      const prevEl = el.querySelector('.swiper-button-prev');

      const options = {
        loop: true,
        effect: transition,
        speed: 800,
        watchSlidesProgress: true,
        grabCursor: true,
        preloadImages: false, // Performance: let browser handle native lazy loading
        lazy: false,
        autoplay: autoplay ? {
          delay: speed,
          disableOnInteraction: false,
        } : false,
        pagination: {
          el: paginationEl,
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
      };

      if (transition === 'fade') {
        options.fadeEffect = { crossFade: true };
      }

      try {
        const swiperInstance = new Swiper(el, options);
        el.swiper = swiperInstance;
      } catch (e) {
        console.error('Swiper Init Error:', e);
      }
    });
  };

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSlideshow);
  } else {
    initCustomSlideshow();
  }

  // Handle Shopify Theme Editor events
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-slideshow-id]')) {
      setTimeout(initCustomSlideshow, 100);
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const slideshow = e.target.closest('[data-slideshow-id]');
    if (slideshow && slideshow.swiper) {
      const index = Array.from(slideshow.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'))
        .indexOf(e.target);

      if (index !== -1) {
        slideshow.swiper.slideToLoop(index);
        if (slideshow.swiper.autoplay) {
          slideshow.swiper.autoplay.stop();
        }
      }
    }
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const slideshow = e.target.closest('[data-slideshow-id]');
    if (slideshow && slideshow.swiper && slideshow.swiper.autoplay) {
      slideshow.swiper.autoplay.start();
    }
  });
})();
